import Section from '../../../components/Section';
import MultiIndicator, {MultiIndicatorItem} from '../../../components/MultiIndicator';
import {IDashboardData} from '../../../utils/types';
import {AGE_GROUPS} from '../utils/slugs';

interface Props {
    data: IDashboardData;
}

const TargetSection = ({data}: Props) => {
    const targetRows: MultiIndicatorItem[] = AGE_GROUPS.map((label, i) => {
        const d = data[`target_age_row-${i + 1}`];
        return {label, uoa: d?.uoa ?? null, average: d?.average ?? null};
    });

    return (
        <Section title='II. TARGET DELLE INIZIATIVE'>
            <MultiIndicator
                title='Target delle iniziative a confronto con la media'
                tooltip='Il grafico mostra la distribuzione percentuale delle iniziative del vostro progetto per target di età, a confronto con la media della distribuzione per tutti i progetti. La distribuzione media viene calcolata dividendo, per ciascuna fascia di età, il numero totale di iniziative rivolte a quella fascia per il numero complessivo di iniziative.'
                items={targetRows}
                maxOverride={100}
            />
        </Section>
    );
};

export default TargetSection;
